module.exports = __webpack_public_path__ + "img/setting-2-active.5cb36a77.svg";